import { render } from "./SectionWrapper.vue?vue&type=template&id=2d5f1888&scoped=true"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"

import "./SectionWrapper.vue?vue&type=style&index=0&id=2d5f1888&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5f1888"]])

export default __exports__